import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'
import * as Barcode from 'jsbarcode'

/** 条形码 */
class GLBarcode extends BaseComponent {
	static propTypes = {
		code: PropTypes.string,
		options: PropTypes.object,
	}

	static defaultProps = {
		code: '',
		options: {
			width: 2,
			height: 100,
			margin: 0,
			lineColor: '#000000',
			background: '#ffffff',
		},
	}

	constructor(props) {
		super(props)
		this.barcodeRef = React.createRef()
		this.state = {
			src: '',
		}
	}

	componentDidMount() {
		this.resetCode()
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// console.log('componentDidUpdate', prevProps, prevState)
		if (prevProps.code !== this.props.code) {
			if (_.isEmpty(this.props.code) || !_.isString(this.props.code)) {
				return
			}
			this.resetCode()
		}
	}

	resetCode() {
		// console.log('====', this.props.options)
		if (this.barcodeRef.current) {
			Barcode(this.barcodeRef.current, this.props.code, this.props.options)
			const src = this.barcodeRef.current.toDataURL('image/png')
			this.setState({
				src,
			})
		}
	}

	render() {
		if (_.isEmpty(this.props.code) || !_.isString(this.props.code)) {
			return null
		}

		if (_.isHasValue(this.state.src)) {
			return <img style={{ width: '100%' }} src={this.state.src} />
		}

		return <canvas ref={this.barcodeRef}></canvas>
	}
}

export default GLBarcode
